import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingService from "@app/overviews/network-benchmarking-dashboard/benchmarkingService";
import { BenchmarkingFilterData } from "@app/overviews/network-benchmarking-dashboard/filters/shared/BenchmarkingFilterData";

export interface MedicarePrimaryFiltersResult {
  isLoading: boolean;
  primaryFilterData: BenchmarkingFilterData | undefined;
}

export const MEDICARE_PRIMARY_FILTERS_QUERY_KEY_PREFIX = "medicare-primary-filters";

export const useMedicarePrimaryFilters = (clientId: number | undefined, enabled: boolean): MedicarePrimaryFiltersResult => {
  const benchmarkingService = useMemo(() => new BenchmarkingService(), []);

  const queryResult = useQuery<BenchmarkingFilterData>({
    enabled,
    queryFn: ({ signal }) => benchmarkingService.getBenchmarkingPrimaryFilterData(signal),
    queryKey: [MEDICARE_PRIMARY_FILTERS_QUERY_KEY_PREFIX, clientId],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    primaryFilterData: queryResult.data,
  };
}

export default useMedicarePrimaryFilters;
